import {HiddenSelectionBanner} from './components/HiddenSelectionBanner'
import {ListMessage} from './components/ListMessage'
import {PartialResultsRow} from './components/PartialResultsRow'
import {PickerList, type PickerListProps} from './components/PickerList'
import type {IPickerItem} from './types'

interface PickerListBodyProps<T extends IPickerItem> extends PickerListProps<T> {
  hiddenSelectedCount: number
  blankMessage: React.ReactNode | string | null
  totalItemsCount: number
  isFiltered: boolean
}

export function PickerListBody<T extends IPickerItem>({
  hiddenSelectedCount,
  blankMessage,
  totalItemsCount,
  isFiltered,
  ...pickerListProps
}: PickerListBodyProps<T>) {
  return (
    <>
      {isFiltered && <HiddenSelectionBanner hiddenSelectedCount={hiddenSelectedCount} />}
      {blankMessage ? <ListMessage>{blankMessage}</ListMessage> : <PickerList {...pickerListProps} />}
      {hiddenSelectedCount > 0 && !isFiltered ? (
        <PartialResultsRow itemCount={pickerListProps.items.length} totalCount={pickerListProps.selectedItems.length} />
      ) : (
        <PartialResultsRow itemCount={pickerListProps.items.length} totalCount={totalItemsCount} />
      )}
    </>
  )
}
